import type { ErrorLike } from "@apollo/client";
import { Column } from "@stenajs-webui/core";
import type { FC } from "react";

import type { SearchBookingsResult } from "../../../../common/graphql/useSearchBookingsResult";
import type { InvalidSearchQueryReason } from "../../../../common/utils/stringUtil";
import type { SearchResultColumn } from "../utils/searchResultColumns";
import { BookingSearchListInnerContent } from "./BookingSearchListInnerContent";
import { SearchQueryInformation } from "./SearchQueryInformation";

export interface BookingSearchListProps {
  data: SearchBookingsResult;
  error: ErrorLike | undefined;
  invalidSearchQueryReason: InvalidSearchQueryReason | null;
  loading: boolean;
  onClickActiveTransports: () => void;
  onClickResult: (bookingNo: number) => void;
  onClickTransportHistory: () => void;
  searchColumns: SearchResultColumn[];
  searchQuery: string;
}

export const BookingSearchList: FC<BookingSearchListProps> = ({
  onClickResult,
  searchColumns,
  loading,
  data,
  onClickActiveTransports,
  onClickTransportHistory,
  error,
  invalidSearchQueryReason,
  searchQuery,
}) => (
  <Column spacing indent>
    <SearchQueryInformation
      invalidSearchQueryReason={invalidSearchQueryReason}
    />

    <BookingSearchListInnerContent
      searchColumns={searchColumns}
      loading={loading}
      error={error}
      data={data}
      searchQuery={searchQuery}
      onClickResult={onClickResult}
      onTransportClick={onClickActiveTransports}
      onHistoryClick={onClickTransportHistory}
    />
  </Column>
);
